import { render, staticRenderFns } from "./movie-swipe.vue?vue&type=template&id=0409af2f&scoped=true"
import script from "./movie-swipe.vue?vue&type=script&lang=js"
export * from "./movie-swipe.vue?vue&type=script&lang=js"
import style0 from "./movie-swipe.vue?vue&type=style&index=0&id=0409af2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0409af2f",
  null
  
)

export default component.exports